export default __webpack_public_path__ + "static/media/bg-bottom.caabcd7b.png";